import {ChangeDetectionStrategy, Component, EventEmitter, Output} from '@angular/core';
import {AppIconComponent} from "@shared/components/app-icon";

@Component({
  selector: 'app-sticky-bar',
  templateUrl: './sticky-bar.component.html',
  styleUrl: './sticky-bar.component.scss',
  standalone: true,
  imports: [
    AppIconComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StickyBarComponent {

  @Output() scrollToTop = new EventEmitter<void>();

  onScrollToTop(): void {
    this.scrollToTop.emit();
  }
}
